import { get } from "../../utils/objectHelpers";

$ {
    const mainModules = get(input, 'regionsData.MAIN', []);
    const spinnerModule = mainModules.find(m => m.meta && m.meta.name === 'LOADING_SPINNER');
    const modules = get(input, 'regionsData.TAB0', []);
    const gridModule = modules.find(m => m.meta && m.meta.name === 'ITEMS_GRID');
    const sortModule = modules.find(m => m.meta && m.meta.name === 'SORT_ITEMS_SELECTION');
    const container = get(gridModule, "containers.[0]", {});
    const cards = get(container, "cards", []);
    const imageSize = gridModule && gridModule.isSmall ? 170 : 300;
    const title = get(gridModule, "containers.[0].title", null);
    const seeAllTextSpans = get(container, "seeAll.textSpans", []);
    const seeAllAction = get(container, "seeAll.action", {});
}

<section class="str-items-grid app-layout__block--gutters">
    <div class="str-marginals str-marginals__header">
        <str-title ...title />
        <!-- Only show Sort menu if there are items to sort -->
        <if(cards.length)>
            <str-sort ...sortModule title=title/>
        </if>
    </div>
    <section class="str-items-grid__container">
        <for|card, idx| of=cards>
            <str-item-card key=idx ...card class=card._type imageSize=imageSize isSmall=gridModule.isSmall />
        </for>
    </section>
    <div class="str-marginals str-marginals__footer">
        <if(cards.length)>
            <ebay-button
                class="str-marginals__footer--button"
                priority="primary"
                size="large"
                href=seeAllAction.URL
                fluid
                >
                <str-textual-display textSpans=seeAllTextSpans />
            </ebay-button>
        </if>
        <else>
            <div style="padding: 50px">
                <!-- To add some spacing before the SEEK Survey buttons at the bottom of page -->
            </div>
        </else>
    </div>
    <str-loading-spinner ...spinnerModule spinnerId="listingsLoadingSpinner"/> 
</section>
